import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cb033c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-5 d-flex justify-content-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "my-5" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" The Memphis Lions are a set of 9,999 unique, hand-drawn, digital avatars, designed in partnership with Memphis and to embody the philosophy of Memphis. Each Memphis Lion entitles the owner to unique tangible benefits in both the digital and physical worlds, as well as access to our immersive and content-rich meta spaces. Explore this site to learn more and prepare yourself to ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" #LiveLikeALion! ")
const _hoisted_7 = { class: "my-5 d-flex justify-content-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "cta-header" }, "Explore the club", -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "d-flex flex-column align-items-center" }
const _hoisted_11 = { class: "info-redirect" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Don't forget to visit our ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Info Kiosk")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" and ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("NFT Gallery")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" for everything MLC. ")

import MintModal from '@/components/modals/MintModal.vue';
import MintLive from '@/components/modals/MintLive.vue';
import { onMounted, ref } from 'vue';
import PageFooter from '@/components/PageFooter.vue';
import CTAButton from '@/components/buttons/CTAButton.vue';
import { getCurrentInstance } from 'vue';
import { isMobile } from 'mobile-device-detect';
import { router } from '@/router';

interface IBrowserDetect {
  isChrome: boolean;
  isChromeIOS: boolean;
  isEdge: boolean;
  isFirefox: boolean;
  isIE: boolean;
  isIOS: boolean;
  isOpera: boolean;
  isSafari: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const showMintModal = ref(false);
const showMintLive = ref(true);

const onShowMintLiveClose = () => {
  showMintModal.value = false;
  window.open('https://mint.memphislionsclub.com', '_blank');
};

return (_ctx: any,_cache: any) => {
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, null, {
    default: _withCtx(() => [
      (showMintModal.value)
        ? (_openBlock(), _createBlock(MintModal, {
            key: 0,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (showMintModal.value = false))
          }))
        : _createCommentVNode("", true),
      (showMintLive.value)
        ? (_openBlock(), _createBlock(MintLive, {
            key: 1,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (showMintLive.value = false)),
            onAction: onShowMintLiveClose
          }))
        : _createCommentVNode("", true),
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("img", {
          class: "header-img",
          src: require('@/assets/mlc-logo-fill.png'),
          alt: "MLC"
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_b_link, {
            class: "intro-link fw-bold",
            href: "https://twitter.com/search?q=%23LiveLikeALion",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_b_link, { to: "home" }, {
            default: _withCtx(() => [
              _createVNode(CTAButton, null, {
                header: _withCtx(() => [
                  _hoisted_8
                ]),
                image: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "cta-image",
                    src: require('@/assets/jungle.png'),
                    alt: "MLC"
                  }, null, 8, _hoisted_9)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("footer", _hoisted_10, [
        _createElementVNode("p", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_b_link, { to: "info" }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _hoisted_14,
          _createVNode(_component_b_link, { to: "gallery" }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _hoisted_16
        ])
      ]),
      _createVNode(PageFooter)
    ]),
    _: 1
  }))
}
}

})